import api from './api';

// URL de base pour les endpoints de réseau
const NETWORKS_ENDPOINT = '/networks';

const networkService = {
  // Récupérer tous les réseaux
  getNetworks: async (includeInactive = false) => {
    try {
      const response = await api.get(NETWORKS_ENDPOINT, {
        params: { includeInactive }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des réseaux:', error);
      throw error;
    }
  },

  // Récupérer un réseau par son ID
  getNetworkById: async (id) => {
    try {
      const response = await api.get(`${NETWORKS_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération du réseau ${id}:`, error);
      throw error;
    }
  },

  // Créer un nouveau réseau (admin seulement)
  createNetwork: async (networkData) => {
    try {
      const response = await api.post(NETWORKS_ENDPOINT, networkData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du réseau:', error);
      throw error;
    }
  },

  // Mettre à jour un réseau (admin seulement)
  updateNetwork: async (id, networkData) => {
    try {
      const response = await api.put(`${NETWORKS_ENDPOINT}/${id}`, networkData);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour du réseau ${id}:`, error);
      throw error;
    }
  },

  // Supprimer un réseau (admin seulement)
  deleteNetwork: async (id) => {
    try {
      const response = await api.delete(`${NETWORKS_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression du réseau ${id}:`, error);
      throw error;
    }
  }
};

export default networkService;
